import {ReviewsPageDisplay} from "../../../components/reviews/display";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {StyledReviewsPageWrapper} from "../../../styles/reviews";

export default function ReviewsPage() {
  const pageTitle = "Reviews";
  return (
    <DashboardWrapper pageTitle={pageTitle}>
      <StyledPageHeader>Reviews</StyledPageHeader>
      <StyledReviewsPageWrapper>
        <ReviewsPageDisplay />
      </StyledReviewsPageWrapper>
    </DashboardWrapper>
  );
}
